const awaitableActionResolver = () => (next) => (action) => {
  const { payload } = action;
  const { __resolve__ } = payload || {};

  if (__resolve__) {
    __resolve__();
  }

  next(action);
};

export default awaitableActionResolver;
